import Tooltip from '../../../../../../common/_custom/Tooltip/Tooltip';
import { validateCIN } from '../../../../../../utils/utils';
import { BASIC_DETAILS_LABELS } from './constants';
import styles from './BasicDetailsSidebar.module.scss';

interface BasicDetailsSidebarProps {
    panNumber?: string;
    cinNumber?: string;
    gstin?: any[];
    headquarterLocation?: { fullAddress?: string };
}

const BasicDetailsSidebar = ({ panNumber, cinNumber, gstin, headquarterLocation }: BasicDetailsSidebarProps) => {
    const hasData =
        (panNumber && panNumber !== '') ||
        (cinNumber && cinNumber !== '') ||
        (gstin && gstin.length > 0) ||
        headquarterLocation?.fullAddress;

    if (!hasData) return null;

    const getGstInValue = (gstinObj: any) => {
        const [, gstinValue] = Object.entries(gstinObj)[0] as [string, string];
        return gstinValue;
    };

    const getToolTipContent = (gstinList: any[]) => (
        <div>
            {gstinList?.map((gstinObj) => {
                const [stateName, gstinValue] = Object.entries(gstinObj)[0] as [string, string];
                return (
                    <div className={styles.GstTooltip} key={`${stateName}-${gstinValue}`}>
                        {stateName}:<span className={styles.Bold}> {gstinValue} </span>
                    </div>
                );
            })}
        </div>
    );

    return (
        <div className={styles.BasicDetailsSidebar}>
            <div className={styles.Header}>
                <div className={styles.Heading}>{BASIC_DETAILS_LABELS.HEADING}</div>
            </div>
            <div className={styles.Body}>
                {panNumber && (
                    <div className={styles.Row}>
                        <span className={styles.Label}>{BASIC_DETAILS_LABELS.PAN}</span>
                        <span className={styles.Value}>{panNumber}</span>
                    </div>
                )}
                {cinNumber && (
                    <div className={styles.Row}>
                        <span className={styles.Label}>
                            {validateCIN(cinNumber) ? BASIC_DETAILS_LABELS.CIN : BASIC_DETAILS_LABELS.LLPIN}
                        </span>
                        <span className={styles.Value}>{cinNumber}</span>
                    </div>
                )}
                {gstin && gstin.length > 0 && (
                    <div className={styles.Row}>
                        <span className={styles.Label}>{BASIC_DETAILS_LABELS.GST}</span>
                        <div className={styles.GstValues}>
                            <span className={styles.Value}>{getGstInValue(gstin[0])}</span>
                            {gstin.length > 1 && <span className={styles.Value}>{getGstInValue(gstin[1])}</span>}
                            {gstin.length > 2 && (
                                <Tooltip
                                    content={getToolTipContent(gstin.slice(2))}
                                    direction="left"
                                    isOverviewDetail={true}
                                    usePortal={true}
                                    fitContent={true}
                                    contentCss={{ maxHeight: '5rem', overflowY: 'auto', whiteSpace: 'nowrap' }}
                                >
                                    <span className={styles.MoreLink}>+{gstin.length - 2} more</span>
                                </Tooltip>
                            )}
                        </div>
                    </div>
                )}
                {headquarterLocation?.fullAddress && (
                    <div className={styles.Row}>
                        <span className={styles.Label}>{BASIC_DETAILS_LABELS.ADDRESS}</span>
                        <Tooltip
                            content={headquarterLocation.fullAddress}
                            direction="left"
                            isOverviewDetail={true}
                            usePortal={true}
                            fitContent={true}
                        >
                            <span className={styles.AddressValue}>{headquarterLocation.fullAddress}</span>
                        </Tooltip>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BasicDetailsSidebar;
